// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__jf225","rightAdornment":"Header_rightAdornment__2HjMw"};